module.exports = __webpack_public_path__ + "img/rutsjebane.b6b7d2d0.jpg";